import axios from 'axios';
import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';
import validate from 'validate.js';
import _ from 'lodash';
import {addConfirmationUsers} from 'actions/users';

const {
  addRequestError,
  addErrorsSaga,
  addValidateError,
  cleanErrors,
  addAdminDisciplines,
  startRequest,
  endRequest,
  setTempDiscipline
} = actions;

const {
  UPDATE_DISCIPLINE_SAGA,
  LOAD_ADMIN_DISCIPLINES_SAGA,
  ADMIN_DELETE_DISCIPLINES_SAGA,
  CREATE_DISCIPLINE_SAGA,
  API_ADMIN_DISCIPLINES,
  LOAD_DISCIPLINE_SAGA,
  APPROVE_DISCIPLINE_FILTER_SAGA,
  API_CONFIRMATION_USERS
} = constants;

const apiCreateDiscipline = (discipline) => (
  axios.post(API_ADMIN_DISCIPLINES, discipline)
);

const apiUpdateDiscipline = (id, discipline) => (
  axios.put(`/api/v1/admin/disciplines/${id}`, discipline)
);

const apiLoadConfirmationUsers = (page, query, per_page) => {
  return axios.get(API_CONFIRMATION_USERS, {
    params: {
      page: page,
      per_page: 50,
      ...query
    }
  })
};

const apiLoadAdminDisciplines = (page, query) => (
  axios.get(API_ADMIN_DISCIPLINES, {
    params: {
      page,
      per_page: 10,
      ...query
    }
  })
);

const apiLoadDiscipline = (id, params = {}) => (
  axios.get(`/api/v1/admin/disciplines/${id}`, {
    params: {
      ...params
    }
  })
);


const apiDeleteDisciplines = (discipline_ids) => {
  return axios.post('/api/v1/admin/disciplines/destroy', {
    discipline_ids: discipline_ids
  })
}

const formatRequestData = (discipline) => {
  let data = new FormData();
  Object.keys(discipline).forEach(field => {
    data.append(`discipline[${field}]`, discipline[field]);

  })
  // data.append('discipline[logo]', discipline.logo);

  return data;
}


function* createDisciplineSaga({ discipline }) {
  try {
    if (yield select(store => store.requests.indexOf('discipline_create') != -1))
      return;
    yield put(startRequest('discipline_create'));
    const errors = validator.validate(discipline, 'discipline');
    if (errors) {
      yield put(addValidateError(CREATE_DISCIPLINE_SAGA, errors));
      yield put(endRequest('discipline_create'));
      return;
    } else {
      yield put(cleanErrors(CREATE_DISCIPLINE_SAGA))
    }
    // const disciplineRequestData = yield call(formatRequestData, discipline);
    const response = yield call(apiCreateDiscipline, discipline);
    const createdDiscipline = response.data.discipline;
    toast.success('Discipline successfully created!');
    yield put(push('/disciplines/'));
    yield put(endRequest('discipline_create'));
  } catch (e) {
    yield put(endRequest('discipline_create'));
    yield put(addErrorsSaga(CREATE_DISCIPLINE_SAGA, e.response))
  }
}

function* updateDisciplineSaga({ discipline }) {
  try {
    const errors = validator.validate(discipline, 'discipline');
    if (errors) {
      yield put(addValidateError(UPDATE_DISCIPLINE_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(UPDATE_DISCIPLINE_SAGA))
    }

    // const disciplineRequestData = yield call(formatRequestData, discipline);
    const response = yield call(apiUpdateDiscipline, discipline.id, discipline);
    toast.success('Disciplines successfully updated!')
    yield put(push('/disciplines/'))
  } catch (e) {
    yield put(addErrorsSaga(UPDATE_DISCIPLINE_SAGA, e.response))
  }
}

function* deleteDisciplines({ discipline_ids }) {
  if (!discipline_ids.length)
    return;
  const disciplineIds = discipline_ids;
  try {
    yield call(apiDeleteDisciplines, disciplineIds);
    toast.success('Disciplines successfully deleted!');
    const query = yield select(state => state.disciplines.admin.list.query) || {};
    const page = yield select(state => state.disciplines.admin.list.page) || 1;
    yield call(loadAdminDisciplines, { page, query });
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_DELETE_DISCIPLINES_SAGA, e.response))
  }
}

function* loadAdminDisciplines({ page = 1, query = {} }) {
  try {
    const response = yield call(apiLoadAdminDisciplines, page, query);
    const disciplines = response.data.disciplines;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addAdminDisciplines(disciplines, count, page, totalPages, query));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}

function* loadDashboardAdminDisciplines({ page = 1, query = {} }) {
  try {
    const response = yield call(apiLoadAdminDisciplines, page, query);
    const disciplines = response.data.disciplines;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addAdminDisciplines(disciplines, count, page, totalPages, query));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}

function* approveDisciplineSaga({page = 1, query = {}, per_page = 5}) {
  try {
    const response = yield call(apiLoadConfirmationUsers, page, query, per_page);
    const users = response.data.confirmation_users;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addConfirmationUsers(users, count, page, totalPages, query));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}


function* loadDisciplineSaga({ id }) {
  try {
    const response = yield call(apiLoadDiscipline, id);
    const discipline = response.data.discipline;
    yield put(setTempDiscipline(discipline))

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}


function* __approveDisciplineSaga() {
  yield takeEvery(APPROVE_DISCIPLINE_FILTER_SAGA, approveDisciplineSaga)
}

function* __createDisciplineSaga() {
  yield takeEvery(CREATE_DISCIPLINE_SAGA, createDisciplineSaga);
}

function* __updateDisciplineSaga() {
  yield takeEvery(UPDATE_DISCIPLINE_SAGA, updateDisciplineSaga);
}

function* __deleteDisciplineSaga() {
  yield takeEvery(ADMIN_DELETE_DISCIPLINES_SAGA, deleteDisciplines);
}

function* __loadAdminDisciplines() {
  yield takeEvery(LOAD_ADMIN_DISCIPLINES_SAGA, loadAdminDisciplines);
}

function* __loadDashboardAdminDisciplines() {
  yield takeEvery(LOAD_ADMIN_DISCIPLINES_SAGA, loadDashboardAdminDisciplines);
}

function* __loadDisciplineSaga() {
  yield takeEvery(LOAD_DISCIPLINE_SAGA,loadDisciplineSaga);
}

export {
  __createDisciplineSaga,
  __updateDisciplineSaga,
  __deleteDisciplineSaga,
  __loadAdminDisciplines,
  __loadDisciplineSaga,
  __loadDashboardAdminDisciplines,
  __approveDisciplineSaga
};



// WEBPACK FOOTER //
// ./src/sagas/admin/disciplines.js